var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 51,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F6F6F6",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    d: "M29.462 8H8v27.757m27.27-22.434V43H14.88M8 39.257V43h3.524"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#home-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F6F6F6",
    strokeLinejoin: "round",
    strokeOpacity: 0.9,
    strokeWidth: 2,
    d: "M29.462 8H8v27.757m27.27-22.434V43H14.88M8 39.257V43h3.524"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "home-icon_svg__a",
    width: 43.271,
    height: 51,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1047_57",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "home-icon_svg__b",
    width: 31.271,
    height: 39,
    x: 6,
    y: 6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1047_57",
    stdDeviation: 0.5
  })))));
};
export { SvgHomeIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA0NCA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDIiPgo8ZyBpZD0iUmVjdGFuZ2xlIDIiIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2ZfMTA0N181NykiPgo8cGF0aCBkPSJNMjkuNDYxOCA4SDhMOCAzNS43NTY5TTM1LjI3MDggMTMuMzIyOVY0M0gxNC44Nzg1TTggMzkuMjU2OUw4IDQzSDExLjUyNDMiIHN0cm9rZT0iI0Y2RjZGNiIgc3Ryb2tlLW9wYWNpdHk9IjAuOCIgc3Ryb2tlLXdpZHRoPSI4Ii8+CjwvZz4KPGcgaWQ9IlJlY3RhbmdsZSAzIiBmaWx0ZXI9InVybCgjZmlsdGVyMV9mXzEwNDdfNTcpIj4KPHBhdGggZD0iTTI5LjQ2MTggOEg4TDggMzUuNzU2OU0zNS4yNzA4IDEzLjMyMjlWNDNIMTQuODc4NU04IDM5LjI1NjlMOCA0M0gxMS41MjQzIiBzdHJva2U9IiNGNkY2RjYiIHN0cm9rZS1vcGFjaXR5PSIwLjkiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZl8xMDQ3XzU3IiB4PSIwIiB5PSIwIiB3aWR0aD0iNDMuMjcwOCIgaGVpZ2h0PSI1MSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfMTA0N181NyIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyMV9mXzEwNDdfNTciIHg9IjYiIHk9IjYiIHdpZHRoPSIzMS4yNzA4IiBoZWlnaHQ9IjM5IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjAuNSIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzEwNDdfNTciLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";